// components/citationTypes/SeedFileViewer.tsx
import React from "react";
import { ImCross } from "react-icons/im";
import { Typography } from "@material-tailwind/react";
import ReactQuill from "react-quill";

interface Props {
    seedFileData: any;
    isLoading: boolean;
    error: string | null;
    onClose: () => void;
    formatDate: (dateString: string) => string | null;
}

const ExclusiveContentViewer: React.FC<Props> = ({ seedFileData, isLoading, error, onClose }) => {
    if (isLoading) {
        return (
            <div className="p-5 justify-center items-center h-full card_bg_color card_text_color">
                <ImCross onClick={onClose} className="cursor-pointer" />
                <div className="max-w-full animate-pulse">
                    {[6, 4, 2, 2, 11, 11, 11, 11, 11].map((w, idx) => (
                        <Typography key={idx} as="div" variant="paragraph" className={`mb-2 h-2 w-${w}/12 rounded-full bg-gray-500`}>
                            &nbsp;
                        </Typography>
                    ))}
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-5 text-center font-bold card_bg_color h-full card_text_color">
                <ImCross onClick={onClose} className="cursor-pointer" />
                <h2>Oops, something went wrong.</h2>
            </div>
        );
    }

    return (
        <div className="p-4 pb-20 card_bg_color h-full card_text_color">
            <div className="p-3 flex items-center justify-between relative">
                <ImCross onClick={onClose} className="cursor-pointer" />
                <p className="absolute left-1/2 transform -translate-x-1/2 text-2xl text-center px-4 text-ellipsis overflow-hidden whitespace-nowrap w-2/3" title={seedFileData?.title}>
                    {seedFileData?.title}
                </p>
            </div>

            {seedFileData?.description && (
                <div className="my-5 text-justify flex flex-col flex-1 overflow-hidden h-full">
                    <h3 className="font-bold mb-2">Description:</h3>
                    <div className="flex-1 overflow-auto text-white">
                        <ReactQuill
                            readOnly
                            modules={{ toolbar: false }}
                            value={seedFileData?.description}
                            className=""
                            style={{ color: "black", height: "100%" }}
                        />
                    </div>
                </div>
            )}

            {!seedFileData?.title && !seedFileData?.author && !seedFileData?.description && !seedFileData?.suggestion && (
                <div className="text-center font-bold">
                    <h2>Source not found.</h2>
                </div>
            )}
        </div>
    );
};

export default ExclusiveContentViewer;
